import { memo } from 'react';
import { Icon } from '@hotjar/hotsauce';
import { PageVisitEvent } from '@hotjar/webapp/features/Playbacks/types';
import { Time } from './Time';
import { TextContainer, IconContainer, Line, LogText } from './styles';

const InternalNavigatedToLog = ({ event }: { event: PageVisitEvent }): JSX.Element => (
  <Line>
    <IconContainer>
      <Icon icon="hyperlink" color="text_default" size="m" />
    </IconContainer>

    <TextContainer>
      <LogText title={event.text}>{event.text}</LogText>
    </TextContainer>

    <Time event={event} />
  </Line>
);

export const NavigatedToLog = memo(InternalNavigatedToLog);
